import { PartyIdentification } from '../../../../../card/src/types';
import { PartyRole } from '../../../../../transaction/src/contexts/Parameters/types';
import { IUserInfoRepository } from '../entities/IUserInfoRepository';
import { IUserInfoService } from '../entities/IUserInfoService';
import { DashboardData, CardHeaders } from '../entities';
import { EntitlementsData } from '../entities/EntitlementsDataResponseDTO';
import { PartyRelationship } from '../entities/PostLoginCardResponseDTO';

export class DashboardServiceImpl implements IUserInfoService {
  itemRepo: IUserInfoRepository;

  constructor(ir: IUserInfoRepository) {
    this.itemRepo = ir;
    this.GetDashboardData = this.GetDashboardData.bind(this);
    this.GetEntitlementsData = this.GetEntitlementsData.bind(this);
    this.PostLoginCard = this.PostLoginCard.bind(this);
  }

  GetDashboardData(): Promise<DashboardData> {
    return this.itemRepo.GetDashboardData();
  }

  GetEntitlementsData(data: { companyId: string }): Promise<EntitlementsData> {
    return this.itemRepo.GetEntitlementsData(data.companyId);
  }

  PostLoginCard(data: { customerId: string }): Promise<{
    cardHeaders: CardHeaders;
    selectedPartyIdentification?: PartyIdentification;
    partyRelationships?: PartyRelationship[];
    partyRoles?: PartyRole[];
  }> {
    return this.itemRepo.PostLoginCard(data.customerId);
  }
}
